import { AppShell, Footer, Container, Group, Text, Button } from "@mantine/core";
import { Outlet } from "react-router-dom";

export default function AppLayout(){
    return (
        <AppShell 
          footer={
            <Footer height={100} zIndex={99999} p="md" style={{ backgroundColor: "#f5f5f5", borderTop: "1px solid #ddd" }}>
              <Container size="xl">
                <Group position="apart" mb="sm">
                  <Text size="sm" color="dimmed">
                    © {new Date().getFullYear()} Mindful African Initiative. All rights reserved.
                  </Text>
                  <Button
                    component="a"
                    href="https://mindfulafrican.org/terms-and-conditions/"
                    target="_blank"
                    rel="noopener noreferrer"
                    variant="subtle"
                    size="xs"
                  >
                    Terms & Conditions
                  </Button>
                </Group>
                <Text size="xs" color="dimmed">
                  Data contributions help us understand the global implementation of SEE Learning and CBCT practices.
                </Text>
              </Container>
            </Footer>
          }
          styles={{
            main: {
              backgroundColor: "#fafaf8",
              paddingTop: 20,
              paddingLeft: 0,
              paddingRight: 0,
              paddingBottom: 100
            }
          }}
        >
            <Outlet />
        </AppShell>
    )
}